/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CompositionBeautyProfileCheck {
  attributeOptionId?: number;
  category?: string;
  categoryId?: number;
  externalId?: number;
  internalEAN?: string;
  productVariantId?: number;
  productVariantName?: string;
  subscriberCount?: string;
}
